/** Mirrors backend services/scope_hiding.OUT_OF_SCOPE_REASON (facets 1b). */
export const OUT_OF_SCOPE_REASON = "auto:out_of_scope";

type WithReason = { exclusion_reason: string | null };

/** Outside the concept's year range: hidden from the main list, never graded. */
export const isOutOfScope = (p: WithReason) => p.exclusion_reason === OUT_OF_SCOPE_REASON;

/** What the Dismissed view and the dismissal count show: every exclusion except out-of-scope. */
export const countsAsDismissed = (p: WithReason) => !!p.exclusion_reason && !isOutOfScope(p);
